import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/common/Icon';
import AuthShell from './AuthShell';

const VerifyAccount = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const confirmEmail = async () => {
      const confirmation_token = sessionStorage.getItem('confirmation_token');
      try {
        const response = await fetch('/api/confirm-email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(confirmation_token),
        });

        if (response.ok) {
          const data = await response.json();
          setMessage(data.message);
          setTimeout(() => navigate('/login'), 5000);
        } else {
          const errorData = await response.json();
          throw new Error(errorData.message || 'somethingWentWrong');
        }
      } catch (err) {
        setError(err.message);
      }
    };

    confirmEmail();
  }, [location, navigate]);

  const status = error ? 'error' : message ? 'success' : 'pending';
  const iconName = status === 'success' ? 'check' : status === 'error' ? 'cross' : 'clock';
  const heroSubtitle =
    status === 'success'
      ? t('redirectingToLogin', { defaultValue: 'Redirecting you to login…' })
      : status === 'error'
      ? null
      : t('pleaseWait');

  return (
    <AuthShell
      title={t('confirmEmail')}
      subtitle={heroSubtitle}
      footer={
        status !== 'pending' && (
          <Link to="/login" className="auth__back-link">
            <Icon name="angle-left" /> {t('backToLogin')}
          </Link>
        )
      }
    >
      <div className="auth__card auth__verify">
        <div className={`auth__verify-icon auth__verify-icon--${status}`}>
          <Icon name={iconName} />
        </div>
        <p className="auth__verify-msg">
          {status === 'pending' && t('pleaseWait')}
          {message && t(message)}
          {error && t(error)}
        </p>
      </div>
    </AuthShell>
  );
};

export default VerifyAccount;
